import React, { Component } from "react";
import DayPicker from "react-day-picker";
import "react-day-picker/lib/style.css";
import "../../../../../assets/less/components/customCalendar.less";
import { getYearMonthPart } from "../../../../../utils";

export default class Calendar extends Component {
  static defaultProps = {
    month: getYearMonthPart(new Date()),
    fromMonth: getYearMonthPart(new Date()),
    availableDays: [],
    selectedDays: undefined
  };

  renderDay = day => {
    const date = day.getDate();
    return <span>{date}</span>;
  };

  render() {
    return (
      <DayPicker
        {...this.props}
        className="client-portal-calendar"
        renderDay={this.renderDay}
        selectedDays={this.props.selectedDays}
        modifiers={{ available: this.props.availableDays }}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/BookingPortal/components/Steps/DrawerContent/Calendar.js